import React from "react";

const PrivacyPolicy = () => {
	return (
		<div className="max-w-3xl mx-auto p-6 text-gray-800">
			<h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
			<p className="mb-4">
				At MaterialLogs.com, we respect your privacy. This policy outlines how we
				collect, use, and protect your information.
			</p>

			<h2 className="text-lg font-semibold mt-4">1. Information We Collect</h2>
			<p className="mb-4">
				We may collect basic information such as your name, email, and usage
				data to enhance your experience.
			</p>

			<h2 className="text-lg font-semibold mt-4">2. How We Use Your Information</h2>
			<p className="mb-4">
				Your data is used to improve our services, provide support, and ensure a
				smooth experience on our platform.
			</p>

			<h2 className="text-lg font-semibold mt-4">3. Data Protection</h2>
			<p className="mb-4">
				We take security seriously and implement measures to protect your
				personal data from unauthorized access.
			</p>

			<h2 className="text-lg font-semibold mt-4">4. Contact Us</h2>
			<p className="mb-4">
				If you have any questions about this policy, please contact us at{" "}
				<a href="mailto:support@materiallogs.com" className="text-blue-500 hover:underline">
					support@materiallogs.com
				</a>.
			</p>

			<p className="text-sm text-gray-600 mt-6">
				Last updated: {new Date().toLocaleDateString()}
			</p>
		</div>
	);
};

export default PrivacyPolicy;
